module.exports = __webpack_public_path__ + "img/img1.a60c6619.png";